import React from 'react';
import { CheckIcon, GiftIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CDV_ANNUAL_URL, CDV_MONTHLY_URL, bonuses, includes, joinSteps, premiumBonus } from '../../data/academiaCdv';
import { trackPage } from '../../utils/analytics';
import { CdvCtaButton } from './CdvCtaButton';
export function OfferAndPricing() {
  return <>
      {/* OFERTA */}
      <section aria-labelledby="oferta-heading" className="w-full bg-[#0B0B0B] border-y border-white/10 px-5 py-16 md:py-24" data-id="element-69" data-mp="1pp0o4e09o4vl">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-70" data-mp="1unbxknmngdda">
          <div className="lg:col-span-3" data-id="element-71" data-mp="1fxxjj284p7rk">
            <h2 id="oferta-heading" className="font-sans text-2xl md:text-4xl font-bold uppercase leading-tight mb-8" data-id="element-72" data-mp="1fx4nowapk2o7">
              Lo que obtienes al unirte hoy
            </h2>
            <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-73" data-mp="2de33tgbcbnng">
              {includes.map(item => <li key={item.name} className="flex gap-4 py-5" data-id="element-74" data-mp="ud71r2ukfu99">
                  <CheckIcon className="mt-1 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-75" data-mp="pevqqosjbdpg" />
                  <div data-id="element-76" data-mp="137lccs45igm1">
                    <p className="font-semibold text-white" data-id="element-77" data-mp="1384xsit0fn4t">{item.name}</p>
                    <p className="mt-1 text-sm text-white/60 leading-relaxed" data-id="element-78" data-mp="yeadbd5kz44o">
                      {item.description}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <aside className="lg:col-span-2 flex flex-col gap-6" data-id="element-79" data-mp="1m564q964jxbe">
            <div className="rounded-2xl border border-white/10 p-6" data-id="element-80" data-mp="1m4d2nli41vzl">
              <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-gold-metallic" data-id="element-81" data-mp="1i4m6f29tenno">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="3nx1903q1wzjl" /> Bonos
              </p>
              <ul className="mt-4 space-y-3" data-id="element-83" data-mp="3jw8yl75g0olq">
                {bonuses.map(bonus => <li key={bonus} className="flex gap-3 text-white/85" data-id="element-84" data-mp="1mvcwepw69bi9">
                    <span className="mt-2.5 h-1 w-4 flex-shrink-0 bg-gold-metallic" aria-hidden="true" data-id="element-85" data-mp="1rsuvloke0cd2" />
                    {bonus}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-2xl border-2 border-gold-metallic bg-gold-metallic/[0.06] p-6" data-id="element-86" data-mp="21p7ponjugs8c">
              <p className="text-sm font-bold uppercase tracking-wider text-gold-metallic" data-id="element-87" data-mp="25rbbo6453f7v">
                Bono exclusivo Plan Premium
              </p>
              <p className="mt-2 font-sans text-lg font-bold uppercase text-white" data-id="element-88" data-mp="2fka27tj75fu4">
                {premiumBonus}
              </p>
            </div>
          </aside>
        </div>
      </section>

      {/* PRECIO */}
      <section id="precio" aria-labelledby="precio-heading" className="w-full px-5 py-16 md:py-24" data-id="element-89" data-mp="2pips5t6hmj21">
        <div className="max-w-5xl mx-auto" data-id="element-90" data-mp="hvenj9m6ummz">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-91" data-mp="hwg39re5fxb1">
            <p className="text-sm font-bold uppercase tracking-wider text-[#FF4D5E]" data-id="element-92" data-mp="du1fqtzjc9df">
              Oferta por tiempo limitado · Cierra el Lunes 12 de Octubre, 11:59
              PM (CDMX)
            </p>
            <h2 id="precio-heading" className="mt-3 font-sans text-2xl md:text-4xl font-bold uppercase leading-tight" data-id="element-93" data-mp="3w58id9pxykl">
              Bloquea tu precio de por vida
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 items-stretch" data-id="element-94" data-mp="wllzr7llr9f8">
            <div className="md:col-span-3 flex flex-col rounded-2xl border-2 border-gold-metallic bg-white/[0.03] p-6 md:p-8" data-id="element-95" data-mp="rsj0ciu595r4">
              <p className="text-sm font-bold uppercase tracking-wider text-gold-metallic" data-id="element-96" data-mp="mu7qw97rgx9f">
                Plan Mensual
              </p>
              <p className="mt-3 flex items-baseline gap-2" data-id="element-97" data-mp="1fjf0q4co199z">
                <span className="font-sans text-6xl md:text-7xl font-extrabold text-white" data-id="element-98" data-mp="1fhu4maapdia0">
                  $47
                </span>
                <span className="text-lg text-white/60" data-id="element-99" data-mp="142h4escwx1d7">USD / mes</span>
              </p>
              <p className="mt-2 text-white/70" data-id="element-100" data-mp="q2xwo0o0js1f">
                Conservas este precio mientras sigas dentro. Cancela cuando
                quieras.
              </p>
              <div className="mt-auto pt-8" data-id="element-101" data-mp="v2aufggfajis">
                <CdvCtaButton trackingId="cdv_mensual_click" href={CDV_MONTHLY_URL} data-id="element-102" data-mp="1irvgi87vhwwa" />
              </div>
            </div>

            <div className="md:col-span-2 flex flex-col rounded-2xl border border-white/15 bg-white/[0.02] p-6 md:p-8" data-id="element-103" data-mp="1nsj4sm4pvzmt">
              <p className="text-sm font-bold uppercase tracking-wider text-white/70" data-id="element-104" data-mp="1e0n6pb2ms9il">
                Plan Premium Anual
              </p>
              <p className="mt-3 flex items-baseline gap-2" data-id="element-105" data-mp="21ppm0c9slq9x">
                <span className="font-sans text-5xl font-extrabold text-white" data-id="element-106" data-mp="26gxwzcqrtjp7">
                  $247
                </span>
                <span className="text-lg text-white/60" data-id="element-107" data-mp="3r6l5s5egc20l">USD / año</span>
              </p>
              <p className="mt-2 text-white/70" data-id="element-108" data-mp="3m9bh4ryvzudt">
                Descuento por pago anual: todo desbloqueado desde el principio +
                Consultoría 1 a 1 de IA.
              </p>
              <div className="mt-auto pt-8" data-id="element-109" data-mp="3vxtfl2jp1pea">
                <a href={CDV_ANNUAL_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage('cdv_anual_click')} className="flex w-full items-center justify-center rounded-xl border-2 border-gold-metallic px-6 py-4 text-center text-sm md:text-base font-bold uppercase text-gold-metallic transition-colors duration-150 ease-out hover:bg-gold-metallic hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-110" data-mp="3vz4rxqr7g5h0">
                  Quiero el Plan Anual
                </a>
              </div>
            </div>
          </div>

          {/* Price-lock transparency */}
          <div className="mt-12 max-w-3xl mx-auto flex gap-4 rounded-2xl border border-white/10 p-6" data-id="element-111" data-mp="3le7dd35qoad1">
            <LockIcon className="mt-1 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-112" data-mp="3qdahmldwacjy" />
            <p className="text-white/70 leading-relaxed" data-id="element-113" data-mp="36zy4ira633w">
              Quiero ser completamente transparente contigo: conforme aumenta el
              contenido, las mentorías y el valor de la comunidad, el precio
              también irá aumentando.{' '}
              <strong className="text-white" data-id="element-114" data-mp="36kudludcgtr6">
                Si entras hoy, nunca volverás a pagar un precio mayor que el que
                bloquees hoy.
              </strong>
            </p>
          </div>

          {/* Join in 3 steps */}
          <div className="mt-16" data-id="element-115" data-mp="2iye4ophc7mgh">
            <h3 className="text-center font-sans text-xl md:text-2xl font-bold uppercase mb-8" data-id="element-116" data-mp="2ixchxnqylbix">
              Únete hoy en 3 pasos
            </h3>
            <ol className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-117" data-mp="2gdpwoyztkdhg">
              {joinSteps.map((step, i) => <li key={step.title} className="flex gap-4" data-id="element-118" data-mp="2bdtt30v1ao2f" data-mpi={i}>
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gold-metallic font-bold text-black" data-id="element-119" data-mp="2bca7qvuitmts">
                    {i + 1}
                  </span>
                  <div data-id="element-120" data-mp="22frne80cv78t">
                    <p className="font-semibold text-white" data-id="element-121" data-mp="1xeu57vfcid7b">{step.title}</p>
                    <p className="mt-1 text-sm text-white/60 leading-relaxed" data-id="element-122" data-mp="1snlu8uydajs1">
                      {step.description}
                    </p>
                  </div>
                </li>)}
            </ol>
          </div>

          <p className="mt-12 flex items-center justify-center gap-2 text-center text-sm text-white/60" data-id="element-123" data-mp="1iq7fczs3e31u">
            <ShieldCheckIcon className="h-4 w-4 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-124" data-mp="1emsy65sf3gmt" />
            Sin permanencia forzosa. Cancela tu membresía cuando quieras.
          </p>
        </div>
      </section>
    </>;
}